import { render, staticRenderFns } from "./EditBoxRichEditor.vue?vue&type=template&id=6bd2742a&scoped=true&"
import script from "./EditBoxRichEditor.vue?vue&type=script&lang=js&"
export * from "./EditBoxRichEditor.vue?vue&type=script&lang=js&"
import style0 from "../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=6bd2742a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd2742a",
  null
  
)

export default component.exports